import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ResultsColumn, ResultsColumnHeader } from '../../DTInfoWidget.styles';
import {
  ButtonIcon,
  DescriptionPopupWrapper,
  OffersInfoHeaderRow,
  OffersInfoRow,
  OffersInfoSubTitleText,
} from './DTRbiOffersInfoWidget.styles';
import { formatDateTime } from '../../../../../util';
import RedemptionStepsList from './RedemptionStepsList/RedemptionStepsList';
import DescriptionPopup from 'components/popups/DescriptionPopup/DescriptionPopup';
import { getRbiAssignedOffers } from 'extractFromState';
import { IconCouponOutlined, IconRoundedExclamationOutlined } from 'components/common/SVGIcons';

const DTRbiOffersInfoWidget = () => {
  const assignedOffers = useSelector(getRbiAssignedOffers);

  // Store the offerId rather than boolean to only display the desired terms.
  const [activePopup, setActivePopup] = useState(null);
  const shouldRenderHowToRedeemColumn = assignedOffers?.some((offer) => offer.redemptionSteps?.length);

  const handlePopup = (event) => {
    // Allows user to click on the information icon to close the popup as well rather than always hitting close.
    const tooltipId = event?.currentTarget?.dataset?.tooltipid;
    const active = !!activePopup && activePopup === tooltipId ? null : tooltipId;
    setActivePopup(active);
  };

  if (!assignedOffers?.length) {
    return <OffersInfoSubTitleText>NO ASSIGNED OFFERS AVAILABLE</OffersInfoSubTitleText>;
  }

  return (
    <>
      <OffersInfoSubTitleText>ASSIGNED OFFERS</OffersInfoSubTitleText>
      <OffersInfoHeaderRow>
        <ResultsColumnHeader>NAME</ResultsColumnHeader>
        <ResultsColumnHeader>DATE ASSIGNED</ResultsColumnHeader>
        <ResultsColumnHeader>EXPIRES ON</ResultsColumnHeader>
        <ResultsColumnHeader>ACTIVATED</ResultsColumnHeader>
        {shouldRenderHowToRedeemColumn ? (
          <ResultsColumnHeader $justifyContent="center">HOW TO REDEEM</ResultsColumnHeader>
        ) : null}
        <ResultsColumnHeader $justifyContent="center">TERMS</ResultsColumnHeader>
      </OffersInfoHeaderRow>
      {assignedOffers.map((offer) => (
        <OffersInfoRow className="fs-block" key={offer.id}>
          <ResultsColumn>{offer.name}</ResultsColumn>
          <ResultsColumn>{formatDateTime(offer.assignedDate)}</ResultsColumn>
          <ResultsColumn>{formatDateTime(offer.expiryDate)}</ResultsColumn>
          <ResultsColumn>{offer.isActive ? 'ACTIVE' : 'INACTIVE'}</ResultsColumn>
          {shouldRenderHowToRedeemColumn ? (
            <ResultsColumn $justifyContent={'center'}>
              {offer.redemptionSteps ? (
                <ButtonIcon data-tooltipid={`${offer.id}-redeem-tt`} onClick={handlePopup}>
                  <IconCouponOutlined width={16} height={16} />
                </ButtonIcon>
              ) : (
                <>&mdash;</>
              )}
              {activePopup === `${offer.id}-redeem-tt` && (
                <DescriptionPopupWrapper>
                  <DescriptionPopup
                    title="How to Redeem the Offer"
                    body={<RedemptionStepsList steps={offer.redemptionSteps} offerId={offer.id} />}
                    closeHandler={handlePopup}
                  />
                </DescriptionPopupWrapper>
              )}
            </ResultsColumn>
          ) : null}
          <ResultsColumn $justifyContent={'center'}>
            {offer.terms ? (
              <ButtonIcon data-tooltipid={`${offer.id}-terms-tt`} onClick={handlePopup}>
                <IconRoundedExclamationOutlined width={16} height={16} />
              </ButtonIcon>
            ) : (
              <>&mdash;</>
            )}
            {activePopup === `${offer.id}-terms-tt` && (
              <DescriptionPopupWrapper>
                <DescriptionPopup title="Terms" body={offer.terms} closeHandler={handlePopup} />
              </DescriptionPopupWrapper>
            )}
          </ResultsColumn>
        </OffersInfoRow>
      ))}
    </>
  );
};
export default DTRbiOffersInfoWidget;
